import { render, staticRenderFns } from "./NFTLogoPayload.vue?vue&type=template&id=580f23b6&scoped=true&"
import script from "./NFTLogoPayload.vue?vue&type=script&lang=ts&"
export * from "./NFTLogoPayload.vue?vue&type=script&lang=ts&"
import style0 from "./NFTLogoPayload.vue?vue&type=style&index=0&id=580f23b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f23b6",
  null
  
)

export default component.exports